import Logger from '../logger';
import event from '../mixins/event';
import simpleParallax from 'simple-parallax-js';

class ImageCollageHero {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ImageCollageHero';

		this.dom = dom;

		this.parallaxImages = this.dom.querySelectorAll(`[data-image-collage-hero-image]`);

	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initParallax();
	}

	/**
	 * initParallax - Initialize the parallax effect
	 */
	initParallax() {
		Logger.info(`${this.NAME} > initParallax`);

		if (!this.parallaxImages) return;

		const delays = [0, 0, 0, 0, 0, 0, 0, 0];
		const scales = [1.5, 2.0, 1.3, 1.5, 1.0];
		const overflows = [true, true, false, true, false, true];

		this.parallaxImages.forEach((dom, idx) => {
			new simpleParallax(dom, {
				delay: delays[idx],
				orientation: 'down',
				scale: scales[idx],
				overflow: overflows[idx],
			});
		});

	}

}

Object.assign(ImageCollageHero.prototype, event);

export default ImageCollageHero;
